import ApiService from '../../services/api.service'
import { Notify } from 'quasar'

export const schedulerOptions = {
  state: {
    schedulerOptions: [],
    schedulerOptionUser: {}
  },
  mutations: {
    setSchedulerOptions(state, schedulerOptions) {
      state.schedulerOptions = schedulerOptions
    },
    setSchedulerOptionUser(state, schedulerOptionUser) {
      state.schedulerOptionUser = schedulerOptionUser
    },
    callbackAddSchedulerOption(state, newOption) {
      state.schedulerOptions.push(newOption)
    },
    callbackUpdateSchedulerOption(state, updatedOption) {
      const index = state.schedulerOptions.findIndex(
        (option) => option.id === updatedOption.id
      )
      if (index !== -1) {
        state.schedulerOptions.splice(index, 1, updatedOption)
      }
    },
    callbackRemoveSchedulerOption(state, optionId) {
      for (var option in state.schedulerOptions) {
        if (state.schedulerOptions[option].id == optionId) {
          state.schedulerOptions.splice(option, 1)
        }
      }
    }
  },
  actions: {
    //Récupère les options du calendrier de l'utilisateur connecté
    async fetchSchedulerOptionUser(context, userId) {
      try {
        const response = await ApiService.getRequest(`/scheduler_options/${userId}`)
        context.commit('setSchedulerOptionUser', response.data)
        return response.data
      } catch (error) {
        // Si l'utilisateur n'a pas d'options (404), utiliser des options par défaut
        if (error.response && error.response.status === 404) {
          //console.log('Aucune option trouvée pour l\'utilisateur ID:', userId, '- Utilisation d\'options par défaut')
          const defaultOptions = {
            weekend: 1,
            week_numbers: 1,
            discreet_conflict_mode: false
          }
          context.commit('setSchedulerOptionUser', defaultOptions)
          return defaultOptions
        } else {
          console.error('Erreur lors du chargement des options:', error)
          throw error
        }
      }
    },
    // POST :: Ajoute un nouvel evenement
    async addSchedulerOptions(context, newOption) {
      try {
        const response = await ApiService.postRequest(
          '/scheduler_options',
          newOption
        )
        if (response.status === 201) {
          context.commit('callbackAddSchedulerOption', response.data)
          // Mettre à jour aussi les options utilisateur
          context.commit('setSchedulerOptionUser', response.data)
          Notify.create({
            message: "Les options ont été créées avec succès.",
            color: 'green'
          })
          return response.data
        } else {
          throw new Error('La requête a échoué.')
        }
      } catch (error) {
        console.error('Erreur lors de la création des options:', error)
        Notify.create({
          message: "Erreur lors de la création des options",
          color: 'red'
        })
        throw error
      }
    },
    async updateUserSchedulerOption(context, { userId, data }) {
      try {
        const response = await ApiService.postRequest(
          `scheduler_options/${userId}`,
          data
        )
        context.commit('setSchedulerOptionUser', response.data)
        return response.data
      } catch (error) {
        console.error(
          "Erreur lors de la mise à jour des options de l'utilisateur:",
          error
        )
        Notify.create({
          message:
            "Une erreur s'est produite lors de la mise à jour des options.",
          color: 'red'
        })
        throw error
      }
    },
    // PUT :: Met à jour un evenement
    // TODO: Quand je fais l'update par le store j'ai l'erreur des 30secondes
    async updateSchedulerOption(context, updatedOption) {
      try {
        const response = await ApiService.patchRequest(
          `/scheduler_Options/${updatedOption.id}`,
          updatedOption
        )
        if (response.status === 200) {
          context.commit('callbackUpdateSchedulerOption', updatedOption)
          Notify.create({
            message: "L'évènement a été mise à jour avec succès.",
            color: 'green'
          })
          return Promise.resolve()
        } else {
          return Promise.reject(new Error('La requête a échoué.'))
        }
      } catch (error) {
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
        return Promise.reject(error)
      }
    },
    // DELETE :: Supprime un evenement
    async removeSchedulerOption(context, OptionId) {
      try {
        const response = await ApiService.deleteRequest(
          `/scheduler_Options/${OptionId}`
        )
        if (response.status === 204) {
          context.commit('callbackRemoveSchedulerOption', OptionId)
          Notify.create({
            message: "L'évènement a été supprimée avec succès.",
            color: 'green'
          })
          return Promise.resolve()
        } else {
          return Promise.reject(new Error('La requête a échoué.'))
        }
      } catch (error) {
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
        return Promise.reject(error)
      }
    }
  },
  getters: {
    getSchedulerOptions(state) {
      return state.schedulerOptions
    },
    getSchedulerOptionUser(state) {
      return state.schedulerOptionUser
    }
  }
}
